import { Dispatcher } from "../../dispatcher";

const eventName = 'tabHiddenUpdated'
const dispatcher = new Dispatcher()
function init() {
    // 不同浏览器 hidden 名称
    let hiddenProperty = 'hidden' in document ? 'hidden' :
        'webkitHidden' in document ? 'webkitHidden' :
            'mozHidden' in document ? 'mozHidden' :
                '';
    // 不同浏览器的事件名
    let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    let onVisibilityChange = function() {
        const isActive = !(document as any)[hiddenProperty]
        tabActivity.isActive = isActive
        dispatcher.dispatch(eventName, isActive)
    }
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);   // 添加元素事件句柄
    onVisibilityChange()
}

export const tabActivity = {
    init,
    listen:(callback: (isActive: boolean) => void) => {
        return dispatcher.addListener(eventName, callback)
    },
    isActive:false
}
